import { useEffect, useState } from 'react'
import { useSearch } from 'wouter'
import queryString from 'query-string'

import { Dialog } from '@/components/ui/dialog'
import { Spinner } from '@/components/ui/spinner'
import { useDocumentPageQuery } from '../DocumentPage/queries'
import { ProjectTracker } from '../DocumentPage/components/Documents/ProjectTracker'
import { WorkInstructions } from '../DocumentPage/components/Documents/WorkInstructions'
import { DownloadPDFDialogContent } from '@/components/collaborating/PDFDownloadButton/DownloadPDFDialogContent'
import { usePDFDownloadEnabled } from '@/components/collaborating/PDFDownloadButton/hooks/usePDFDownloadEnabled'
import { usePDFDownloadTrigger } from '@/components/collaborating/PDFDownloadButton/hooks/usePDFDownloadTrigger'

export const PDFPage = () => {
  const searchParams = useSearch()
  const enabled = usePDFDownloadEnabled()
  const triggerDownload = usePDFDownloadTrigger()
  const { isLoading, data } = useDocumentPageQuery()
  const [isRendered, setIsRendered] = useState(false)
  const { triggerPrint, openDialog, size } = queryString.parse(
    searchParams,
  ) as {
    triggerPrint?: boolean
    openDialog?: boolean
    size?: string
  }
  const printPageSize = size === '792px 612px' ? '11in 8.5in' : size

  useEffect(() => {
    if (enabled) {
      triggerDownload()
        .then(() => {
          document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
            img.setAttribute('loading', 'eager')
          })

          setTimeout(() => {
            setIsRendered(true)
          }, 100)
        })
        .catch((error) => {
          console.error('Error triggering download:', error)
        })
    }
  }, [enabled, openDialog, triggerDownload])

  useEffect(() => {
    if (isRendered && triggerPrint) window.print()
  }, [isRendered, triggerPrint])

  if (isLoading) {
    return (
      <div
        data-testid="pdf-download-spinner"
        className="flex items-center justify-center w-full h-screen"
      >
        <Spinner />
      </div>
    )
  }

  return (
    <>
      {openDialog && !isRendered && (
        <Dialog open={!isRendered}>
          <DownloadPDFDialogContent />
        </Dialog>
      )}

      <div className="w-full h-screen bg-white print:h-auto print:w-[1056px] print:overflow-visible">
        <style>
          {`
          @media print {
            @page {
              size: ${printPageSize ? printPageSize : 'letter landscape'};
              margin: 0;
            }
            html,
            body,
            #root {
              width: 1056px;
              margin: 0;
              padding: 0;
              background: white;
            }
            body {
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
          [data-placeholder] {
            visibility: hidden !important;
          }
          [data-disableprint] {
            visibility: hidden !important;
          }
        `}
        </style>
        {data?.documentType === 'project_tracker' ? (
          <ProjectTracker />
        ) : (
          <WorkInstructions />
        )}
      </div>
    </>
  )
}
